<template>
  <div style="background: #f7f8fa">
    <my-head></my-head>
    <div class="apply minH">
      <div class="crumbs">
        首页 > 知产质押融资 >
        <span style="color: #1d2129">融资申请</span>
      </div>

      <div class="apply_title">融资申请</div>

      <div class="apply_form">
        <el-form
          label-position="top"
          label-width="80px"
          :model="formApply"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="申请人姓名：" prop="name">
            <el-input v-model="formApply.name" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="申请人电话：" prop="phone">
            <el-input v-model="formApply.phone" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="企业名称：" prop="enterprise">
            <el-input
              v-model="formApply.enterprise"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="所在职位：" prop="career">
            <el-input
              v-model="formApply.career"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="附件：">
            <div class="flex-left-center">
              <el-upload
                class="avatar-uploader"
                :action="burl + '/api/v1/upload'"
                multiple
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :limit="1"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>

              <a
                class="service_qd"
                :href="downloadUrl"
                download="国际平台—预评估资料清单.docx"
              >
                下载附件模版
              </a>
            </div>
          </el-form-item>

          <div class="buttons flex-center">
            <el-button @click="Return">取消</el-button>
            <el-button type="primary" @click="onSubmit('ruleForm')">
              提交
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
import { getRequest, postRequest } from "../../api/api";
import { baseUrl } from "../../api/constant";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      formApply: {
        name: "", //名字
        phone: "", //电话
        enterprise: "", //企业名称
        career: "", //所在职位
        attachment: null, //附件
      },
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入", trigger: "blur" },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
            message: "请输入正确的手机号码或者座机号",
          },
        ],
        enterprise: [{ required: true, message: "请输入", trigger: "blur" }],
        career: [{ required: true, message: "请输入", trigger: "blur" }],
      },
    };
  },
  computed: {
    burl() {
      return baseUrl;
    },
    downloadUrl() {
      let url = window.location.href;
      return `${url.split("#")[0]}static/国际平台—预评估资料清单.docx`;
    },
  },
  methods: {
    // 提交
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.formApply;
          postRequest({ url: "/api/v1/application/create", data }).then(
            (res) => {
              if (res.data) {
                this.$message.success("提交成功");
                setTimeout(() => {
                  this.$router.push({
                    name: "my",
                    params: { tab: "质押融资" },
                  });
                }, 1000);
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 取消返回
    Return() {
      this.$router.go(-1);
    },
    // 附件上传.....................
    handleAvatarSuccess(res, file) {
      this.formApply.attachment = res.data.webPath;
      this.$message.success("附件上传成功");
    },
    // .......................
  },
};
</script>

<style lang="scss">
.apply {
  width: 80%;
  margin: 48px auto 60px;
  .buttons {
    width: 100%;
    border-top: 1px solid #e5e6eb;
    padding-top: 32px;
    .el-button {
      padding: 12px 72px;
    }
  }
  .apply_form {
    padding: 24px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e5e6eb;

    .service_qd {
      font-size: 14px;
      margin-left: 16px;
      font-weight: 400;
      color: #165dff;
      cursor: pointer;
    }
  }
  .apply_title {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    margin-bottom: 24px;
  }
}
</style>
